import apiCall from "../AuthorizedApi";
import {
  CustomerDirectoryParams,
  CustomerDirectoryResponse,
} from "../../../Data/customerDirectory.dto";

export const getCustomerDirectoryAPI = async (
  params?: CustomerDirectoryParams
): Promise<CustomerDirectoryResponse> => {
  const queryParams = new URLSearchParams();
  if (params?.page) queryParams.append("page", String(params.page));
  if (params?.page_size) queryParams.append("page_size", String(params.page_size));
  if (params?.search && params.search.trim()) queryParams.append("search", params.search.trim());
  if (params?.source && params.source.trim()) queryParams.append("source", params.source.trim());

  const queryString = queryParams.toString();
  const url = `/quotation/customer-directory/${queryString ? "?" + queryString : ""}`;

  const response: any = await apiCall({
    method: "GET",
    url,
  });

  // apiCall already extracts response.data; handle both raw object and wrapped response safely
  if (response && Array.isArray(response.results)) {
    return response as CustomerDirectoryResponse;
  }
  if (response && response.data && Array.isArray(response.data.results)) {
    return response.data as CustomerDirectoryResponse;
  }
  if (response && typeof response === "object") {
    return {
      count: response.count ?? 0,
      next: response.next ?? null,
      previous: response.previous ?? null,
      results: Array.isArray(response.results) ? response.results : [],
      source_catalog: Array.isArray(response.source_catalog) ? response.source_catalog : [],
    };
  }

  return {
    count: 0,
    next: null,
    previous: null,
    results: [],
    source_catalog: [],
  };
};
